import { BilletModel } from './BilletModel';

export class BillingBilletModel {
    id?:string;
    billet:BilletModel|null = null

    constructor(b?:Partial<BillingBilletModel>) {
        Object.assign(this, b)

        this._parseBillet()
    }

    private _parseBillet():void {
        this.billet = this.billet ? new BilletModel(this.billet) : new BilletModel()
    }
}
